import VueRouter from 'vue-router';


let routes = [
    {path: '/', component: require('./homepage/Homepage.vue').default},
    // {path: '/erp/:tracking_id', component: require('./homepage/Homepage.vue').default},
    // {path: '/contact-us', component: require('./homepage/ContactUs.vue').default},
    // {path: '/pricing', component: require('./pricing/Pricing.vue').default},
    // {path: '/register/:token', component: require('./tryForFree/TryForFree.vue').default},
    // {path: '/registration-thank-you', component: require('./tryForFree/ThankYou.vue').default},
    // {path: '/download/desktop', component: require('./download/Desktop.vue').default},

    // {path: '/user/login', component: require('./login/user/LoginForm.vue').default},
    // {path: '/user/password/forgot', component: require('./login/user/Forgot.vue').default},
    // {path: '/user/password/reset/:token', component: require('./login/user/Reset.vue').default},
    // {path: '/user/email/validation/login/:token', component: require('./login/user/EmailValidation.vue').default},
    // {path: '/client/login', component: require('./login/client/LoginForm.vue').default},
    // {path: '/client/password/forgot', component: require('./login/client/Forgot.vue').default},
    // {path: '/client/password/reset/:token', component: require('./login/client/Reset.vue').default},
    // {path: '/client/email/validation/login/:token', component: require('./login/client/EmailValidation.vue').default},
    // {path: '/company/email/validation/login/:token', component: require('./login/company/EmailValidation.vue').default},
    {
        path: '*',
        redirect: '/',
    },
];

export default new VueRouter({
    routes,
    mode: 'history',
});
